import React, { useState } from 'react';
import { Modal, Button, Space, Input, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Text } = Typography;

export default function ModalValidarFactura({ visible, onClose, onValidar, onRechazar, loading }) {
  const [mostrarRechazo, setMostrarRechazo] = useState(false);
  const [mensajeRechazo, setMensajeRechazo] = useState('');

  const handleValidar = () => {
    onValidar();
    handleCerrar();
  };

  const handleRechazar = () => {
    if (!mensajeRechazo.trim()) {
      return;
    }
    onRechazar(mensajeRechazo);
    handleCerrar();
  };

  const handleCerrar = () => {
    setMostrarRechazo(false);
    setMensajeRechazo('');
    onClose();
  };

  return (
    <Modal
      title="Validar Factura"
      open={visible}
      onCancel={handleCerrar}
      footer={null}
      width={500}
      className="pagos-v2-modal"
    >
      {!mostrarRechazo ? (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Text type="secondary">
            ¿Desea validar o rechazar la factura recibida?
          </Text>

          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={handleValidar}
              loading={loading}
              size="large"
              block
            >
              Validar Factura
            </Button>

            <Button
              type="primary"
              danger
              icon={<CloseCircleOutlined />}
              onClick={() => setMostrarRechazo(true)}
              size="large"
              block
            >
              Rechazar Factura
            </Button>
          </Space>
        </Space>
      ) : (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Text type="secondary">
            Ingrese el motivo del rechazo:
          </Text>

          <TextArea
            placeholder="Escriba el motivo del rechazo de la factura..."
            value={mensajeRechazo}
            onChange={(e) => setMensajeRechazo(e.target.value)}
            rows={4}
            maxLength={500}
            showCount
          />

          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={() => setMostrarRechazo(false)}>
              Cancelar
            </Button>
            <Button
              type="primary"
              danger
              onClick={handleRechazar}
              disabled={!mensajeRechazo.trim()}
              loading={loading}
            >
              Confirmar Rechazo
            </Button>
          </Space>
        </Space>
      )}
    </Modal>
  );
}